import type { TranslationTable } from "@repo/shared/types";

const EN_GB = {
  unread: "Unread",
};

// All 17 locales, like the rest of the bell.
export const T: TranslationTable<typeof EN_GB> = {
  en_GB: EN_GB,
  fr_FR: { unread: "Non lu" },
  es_ES: { unread: "No leído" },
  pt_BR: { unread: "Não lida" },
  de_DE: { unread: "Ungelesen" },
  it_IT: { unread: "Non letta" },
  ar: { unread: "غير مقروء" },
  ja_JP: { unread: "未読" },
  hi_IN: { unread: "अपठित" },
  zh_CN: { unread: "未读" },
  zh_TW: { unread: "未讀" },
  nl_NL: { unread: "Ongelezen" },
  nb_NO: { unread: "Ulest" },
  sv_SE: { unread: "Oläst" },
  fi_FI: { unread: "Lukematon" },
  da_DK: { unread: "Ulæst" },
  is_IS: { unread: "Ólesið" },
};
